import o from "./SVGs/addToFolder.svg.mjs";
import r from "./SVGs/addedtoFolder.svg.mjs";
import t from "./SVGs/aiWand.svg.mjs";
import e from "./SVGs/alarmBell.svg.mjs";
import i from "./SVGs/alignBottom.svg.mjs";
import n from "./SVGs/alignCenter.svg.mjs";
import l from "./SVGs/alignLeft.svg.mjs";
import m from "./SVGs/alignMiddle.svg.mjs";
import a from "./SVGs/alignRight.svg.mjs";
import c from "./SVGs/alignTop.svg.mjs";
import s from "./SVGs/amex.svg.mjs";
import p from "./SVGs/applePay.svg.mjs";
import g from "./SVGs/arrowBack.svg.mjs";
import S from "./SVGs/arrowCursor_blue.svg.mjs";
import f from "./SVGs/arrowCursor_pink.svg.mjs";
import v from "./SVGs/arrowCursor_yellow.svg.mjs";
import u from "./SVGs/arrowDown.svg.mjs";
import d from "./SVGs/arrowRight.svg.mjs";
import w from "./SVGs/arrowUp.svg.mjs";
import k from "./SVGs/attachment.svg.mjs";
import P from "./SVGs/audioModified.svg.mjs";
import B from "./SVGs/blankCalendar_blue.svg.mjs";
import C from "./SVGs/blankCalendar_pink.svg.mjs";
import h from "./SVGs/blankCalendar_yellow.svg.mjs";
import Y from "./SVGs/brain.svg.mjs";
import y from "./SVGs/businessStartup_blue.svg.mjs";
import A from "./SVGs/businessStartup_pink.svg.mjs";
import b from "./SVGs/businessStartup_yellow.svg.mjs";
import M from "./SVGs/calendar.svg.mjs";
import V from "./SVGs/camera_blue.svg.mjs";
import I from "./SVGs/camera_pink.svg.mjs";
import L from "./SVGs/camera_yellow.svg.mjs";
import T from "./SVGs/cameraVideo_blue.svg.mjs";
import F from "./SVGs/cameraVideo_pink.svg.mjs";
import H from "./SVGs/cameraVideo_yellow.svg.mjs";
import G from "./SVGs/chatBubbleTypingOval_blue.svg.mjs";
import E from "./SVGs/chatBubbleTypingOval_pink.svg.mjs";
import U from "./SVGs/chatBubbleTypingOval_yellow.svg.mjs";
import W from "./SVGs/chatTwoBubblesSquare_blue.svg.mjs";
import D from "./SVGs/chatTwoBubblesSquare_pink.svg.mjs";
import O from "./SVGs/chatTwoBubblesSquare_yellow.svg.mjs";
import R from "./SVGs/check.svg.mjs";
import x from "./SVGs/checkCircle.svg.mjs";
import q from "./SVGs/chevronDown.svg.mjs";
import N from "./SVGs/chevronLeft.svg.mjs";
import K from "./SVGs/chevronRight.svg.mjs";
import z from "./SVGs/chevronUp.svg.mjs";
import Q from "./SVGs/circleCheck.svg.mjs";
import Z from "./SVGs/circleClock_black.svg.mjs";
import j from "./SVGs/circleClock_blue.svg.mjs";
import J from "./SVGs/circleClock_pink.svg.mjs";
import X from "./SVGs/circleClock_yellow.svg.mjs";
import _ from "./SVGs/close.svg.mjs";
import $ from "./SVGs/cog.svg.mjs";
import oo from "./SVGs/compass.svg.mjs";
import ro from "./SVGs/controlsForward.svg.mjs";
import to from "./SVGs/controlsPause.svg.mjs";
import eo from "./SVGs/controlsPlay.svg.mjs";
import io from "./SVGs/controlsRecord.svg.mjs";
import no from "./SVGs/controlsRewind.svg.mjs";
import lo from "./SVGs/controlsStop.svg.mjs";
import mo from "./SVGs/dashboardGauge_blue.svg.mjs";
import ao from "./SVGs/dashboardGauge_pink.svg.mjs";
import co from "./SVGs/dashboardGauge_yellow.svg.mjs";
import so from "./SVGs/dinersClub.svg.mjs";
import po from "./SVGs/discover.svg.mjs";
import go from "./SVGs/downloadBottom.svg.mjs";
import So from "./SVGs/downloadSquare_blue.svg.mjs";
import fo from "./SVGs/downloadSquare_pink.svg.mjs";
import vo from "./SVGs/downloadSquare_yellow.svg.mjs";
import uo from "./SVGs/dropbox.svg.mjs";
import wo from "./SVGs/emptyClipboard_blue.svg.mjs";
import ko from "./SVGs/emptyClipboard_pink.svg.mjs";
import Po from "./SVGs/emptyClipboard_yellow.svg.mjs";
import Bo from "./SVGs/erlenmeyerFlask_blue.svg.mjs";
import Co from "./SVGs/erlenmeyerFlask_pink.svg.mjs";
import ho from "./SVGs/erlenmeyerFlask_yellow.svg.mjs";
import Yo from "./SVGs/error.svg.mjs";
import yo from "./SVGs/expandHorizontal.svg.mjs";
import Ao from "./SVGs/expandVertical.svg.mjs";
import bo from "./SVGs/facebook.svg.mjs";
import Mo from "./SVGs/favorite.svg.mjs";
import Vo from "./SVGs/favoriteFilled.svg.mjs";
import Io from "./SVGs/fileDouble.svg.mjs";
import Lo from "./SVGs/filter.svg.mjs";
import To from "./SVGs/filterImage.svg.mjs";
import Fo from "./SVGs/filterMusic.svg.mjs";
import Ho from "./SVGs/filterPlus.svg.mjs";
import Go from "./SVGs/filterVideo.svg.mjs";
import Eo from "./SVGs/folderStar.svg.mjs";
import Uo from "./SVGs/generateImage.svg.mjs";
import Wo from "./SVGs/generateVideo.svg.mjs";
import Do from "./SVGs/gitHub.svg.mjs";
import Oo from "./SVGs/googlePay.svg.mjs";
import Ro from "./SVGs/graphPieChart_blue.svg.mjs";
import xo from "./SVGs/graphPieChart_pink.svg.mjs";
import qo from "./SVGs/graphPieChart_yellow.svg.mjs";
import No from "./SVGs/gridRules_blue.svg.mjs";
import Ko from "./SVGs/gridRules_pink.svg.mjs";
import zo from "./SVGs/gridRules_yellow.svg.mjs";
import Qo from "./SVGs/happyFace_blue.svg.mjs";
import Zo from "./SVGs/happyFace_pink.svg.mjs";
import jo from "./SVGs/happyFace_yellow.svg.mjs";
import Jo from "./SVGs/headphonesCustomer.svg.mjs";
import Xo from "./SVGs/helpChat_blue.svg.mjs";
import _o from "./SVGs/helpChat_pink.svg.mjs";
import $o from "./SVGs/helpChat_yellow.svg.mjs";
import or from "./SVGs/home_blue.svg.mjs";
import rr from "./SVGs/home_pink.svg.mjs";
import tr from "./SVGs/home_yellow.svg.mjs";
import er from "./SVGs/hourGlass_blue.svg.mjs";
import ir from "./SVGs/hourGlass_pink.svg.mjs";
import nr from "./SVGs/hourGlass_yellow.svg.mjs";
import lr from "./SVGs/house.svg.mjs";
import mr from "./SVGs/image.svg.mjs";
import ar from "./SVGs/imageModified.svg.mjs";
import cr from "./SVGs/informationCircle.svg.mjs";
import sr from "./SVGs/informationCircleInverted.svg.mjs";
import pr from "./SVGs/instagram.svg.mjs";
import gr from "./SVGs/interfaceAlertAlarmBell_blue.svg.mjs";
import Sr from "./SVGs/interfaceAlertAlarmBell_pink.svg.mjs";
import fr from "./SVGs/interfaceAlertAlarmBell_yellow.svg.mjs";
import vr from "./SVGs/interfaceAwardTrophy_blue.svg.mjs";
import ur from "./SVGs/interfaceAwardTrophy_pink.svg.mjs";
import dr from "./SVGs/interfaceAwardTrophy_yellow.svg.mjs";
import wr from "./SVGs/interfaceCursorArrow_blue.svg.mjs";
import kr from "./SVGs/interfaceCursorArrow_pink.svg.mjs";
import Pr from "./SVGs/interfaceCursorArrow_yellow.svg.mjs";
import Br from "./SVGs/interfaceFavoriteLike_blue.svg.mjs";
import Cr from "./SVGs/interfaceFavoriteLike_pink.svg.mjs";
import hr from "./SVGs/interfaceFavoriteLike_yellow.svg.mjs";
import Yr from "./SVGs/interfaceImageVideoAudioSubtitles_blue.svg.mjs";
import yr from "./SVGs/interfaceImageVideoAudioSubtitles_pink.svg.mjs";
import Ar from "./SVGs/interfaceImageVideoAudioSubtitles_yellow.svg.mjs";
import br from "./SVGs/interfaceLightingLightBulb_blue.svg.mjs";
import Mr from "./SVGs/interfaceLightingLightBulb_pink.svg.mjs";
import Vr from "./SVGs/interfaceLightingLightBulb_yellow.svg.mjs";
import Ir from "./SVGs/interfaceSearch_blue.svg.mjs";
import Lr from "./SVGs/interfaceSearch_pink.svg.mjs";
import Tr from "./SVGs/interfaceSearch_yellow.svg.mjs";
import Fr from "./SVGs/keyboard_blue.svg.mjs";
import Hr from "./SVGs/keyboard_pink.svg.mjs";
import Gr from "./SVGs/keyboard_yellow.svg.mjs";
import Er from "./SVGs/keyboardArrowRight.svg.mjs";
import Ur from "./SVGs/layers_blue.svg.mjs";
import Wr from "./SVGs/layers_pink.svg.mjs";
import Dr from "./SVGs/layers_yellow.svg.mjs";
import Or from "./SVGs/layoutWindow_blue.svg.mjs";
import Rr from "./SVGs/layoutWindow_pink.svg.mjs";
import xr from "./SVGs/layoutWindow_yellow.svg.mjs";
import qr from "./SVGs/linkedIn.svg.mjs";
import Nr from "./SVGs/loadingRing.svg.mjs";
import Kr from "./SVGs/lock.svg.mjs";
import zr from "./SVGs/lockUnlock.svg.mjs";
import Qr from "./SVGs/login_blue.svg.mjs";
import Zr from "./SVGs/login_pink.svg.mjs";
import jr from "./SVGs/login_yellow.svg.mjs";
import Jr from "./SVGs/logoStoryblocks.svg.mjs";
import Xr from "./SVGs/logoStoryblocksGray.svg.mjs";
import _r from "./SVGs/logoStoryblocksWhite.svg.mjs";
import $r from "./SVGs/maestro.svg.mjs";
import ot from "./SVGs/magicWand_blue.svg.mjs";
import rt from "./SVGs/magicWand_pink.svg.mjs";
import tt from "./SVGs/magicWand_yellow.svg.mjs";
import et from "./SVGs/maker.svg.mjs";
import it from "./SVGs/mastercard.svg.mjs";
import nt from "./SVGs/meetingCamera.svg.mjs";
import lt from "./SVGs/megaphone_blue.svg.mjs";
import mt from "./SVGs/megaphone_pink.svg.mjs";
import at from "./SVGs/megaphone_yellow.svg.mjs";
import ct from "./SVGs/microphone.svg.mjs";
import st from "./SVGs/microphoneOff.svg.mjs";
import pt from "./SVGs/moneyCashBill_blue.svg.mjs";
import gt from "./SVGs/moneyCashBill_pink.svg.mjs";
import St from "./SVGs/moneyCashBill_yellow.svg.mjs";
import ft from "./SVGs/moneyWallet_blue.svg.mjs";
import vt from "./SVGs/moneyWallet_pink.svg.mjs";
import ut from "./SVGs/moneyWallet_yellow.svg.mjs";
import dt from "./SVGs/musicSound.svg.mjs";
import wt from "./SVGs/navigationMenuHorizontal.svg.mjs";
import kt from "./SVGs/navigationMenuVertical.svg.mjs";
import Pt from "./SVGs/newStickyNote_blue.svg.mjs";
import Bt from "./SVGs/newStickyNote_pink.svg.mjs";
import Ct from "./SVGs/newStickyNote_yellow.svg.mjs";
import ht from "./SVGs/oneFingerTap_blue.svg.mjs";
import Yt from "./SVGs/oneFingerTap_pink.svg.mjs";
import yt from "./SVGs/oneFingerTap_yellow.svg.mjs";
import At from "./SVGs/openBook_blue.svg.mjs";
import bt from "./SVGs/openBook_pink.svg.mjs";
import Mt from "./SVGs/openBook_yellow.svg.mjs";
import Vt from "./SVGs/panelCollapse.svg.mjs";
import It from "./SVGs/panelExpand.svg.mjs";
import Lt from "./SVGs/paragraphLeftAlign.svg.mjs";
import Tt from "./SVGs/paragraphsCenterAlign.svg.mjs";
import Ft from "./SVGs/paragraphsRightAlign.svg.mjs";
import Ht from "./SVGs/payPal.svg.mjs";
import Gt from "./SVGs/pen_blue.svg.mjs";
import Et from "./SVGs/pen_pink.svg.mjs";
import Ut from "./SVGs/pen_yellow.svg.mjs";
import Wt from "./SVGs/pencil.svg.mjs";
import Dt from "./SVGs/picturesFolderMemories_blue.svg.mjs";
import Ot from "./SVGs/picturesFolderMemories_pink.svg.mjs";
import Rt from "./SVGs/picturesFolderMemories_yellow.svg.mjs";
import xt from "./SVGs/pin_blue.svg.mjs";
import qt from "./SVGs/pin_pink.svg.mjs";
import Nt from "./SVGs/pin_yellow.svg.mjs";
import Kt from "./SVGs/pinterest.svg.mjs";
import zt from "./SVGs/playList_blue.svg.mjs";
import Qt from "./SVGs/playList_pink.svg.mjs";
import Zt from "./SVGs/playList_yellow.svg.mjs";
import jt from "./SVGs/playVideo.svg.mjs";
import Jt from "./SVGs/plus.svg.mjs";
import Xt from "./SVGs/profileAvatar.svg.mjs";
import _t from "./SVGs/questionmark.svg.mjs";
import $t from "./SVGs/refresh.svg.mjs";
import oe from "./SVGs/screenTv_blue.svg.mjs";
import re from "./SVGs/screenTv_pink.svg.mjs";
import te from "./SVGs/screenTv_yellow.svg.mjs";
import ee from "./SVGs/script_blue.svg.mjs";
import ie from "./SVGs/script_pink.svg.mjs";
import ne from "./SVGs/script_yellow.svg.mjs";
import le from "./SVGs/search.svg.mjs";
import me from "./SVGs/searchSimilar.svg.mjs";
import ae from "./SVGs/settingMenu.svg.mjs";
import ce from "./SVGs/share.svg.mjs";
import se from "./SVGs/shoppingCart_blue.svg.mjs";
import pe from "./SVGs/shoppingCart_pink.svg.mjs";
import ge from "./SVGs/shoppingCart_yellow.svg.mjs";
import Se from "./SVGs/snapchat.svg.mjs";
import fe from "./SVGs/sparkle.svg.mjs";
import ve from "./SVGs/sparkles.svg.mjs";
import ue from "./SVGs/stamp.svg.mjs";
import de from "./SVGs/starFourSided.svg.mjs";
import we from "./SVGs/stopwatch_blue.svg.mjs";
import ke from "./SVGs/stopwatch_pink.svg.mjs";
import Pe from "./SVGs/stopwatch_yellow.svg.mjs";
import Be from "./SVGs/stripe.svg.mjs";
import Ce from "./SVGs/sunCloud_blue.svg.mjs";
import he from "./SVGs/sunCloud_pink.svg.mjs";
import Ye from "./SVGs/sunCloud_yellow.svg.mjs";
import ye from "./SVGs/textBold.svg.mjs";
import Ae from "./SVGs/textInputArea.svg.mjs";
import be from "./SVGs/textItalic.svg.mjs";
import Me from "./SVGs/textStrikeThrough.svg.mjs";
import Ve from "./SVGs/textStyle.svg.mjs";
import Ie from "./SVGs/textUnderline.svg.mjs";
import Le from "./SVGs/thirdEye.svg.mjs";
import Te from "./SVGs/thumbDown.svg.mjs";
import Fe from "./SVGs/thumbUp.svg.mjs";
import He from "./SVGs/trash.svg.mjs";
import Ge from "./SVGs/travelMapEarth_blue.svg.mjs";
import Ee from "./SVGs/travelMapEarth_pink.svg.mjs";
import Ue from "./SVGs/travelMapEarth_yellow.svg.mjs";
import We from "./SVGs/twitter.svg.mjs";
import De from "./SVGs/uploadBottom.svg.mjs";
import Oe from "./SVGs/uploadCircle_blue.svg.mjs";
import Re from "./SVGs/uploadCircle_pink.svg.mjs";
import xe from "./SVGs/uploadCircle_yellow.svg.mjs";
import qe from "./SVGs/userCircleSingle_blue.svg.mjs";
import Ne from "./SVGs/userCircleSingle_pink.svg.mjs";
import Ke from "./SVGs/userCircleSingle_yellow.svg.mjs";
import ze from "./SVGs/userSingle_blue.svg.mjs";
import Qe from "./SVGs/userSingle_pink.svg.mjs";
import Ze from "./SVGs/userSingle_yellow.svg.mjs";
import je from "./SVGs/venmo.svg.mjs";
import Je from "./SVGs/verticalSliderSquare_blue.svg.mjs";
import Xe from "./SVGs/verticalSliderSquare_pink.svg.mjs";
import _e from "./SVGs/verticalSliderSquare_yellow.svg.mjs";
import $e from "./SVGs/video.svg.mjs";
import oi from "./SVGs/videoEditPeel.svg.mjs";
import ri from "./SVGs/videoEditSplit.svg.mjs";
import ti from "./SVGs/videoModified.svg.mjs";
import ei from "./SVGs/videoPlayerAlternate.svg.mjs";
import ii from "./SVGs/view.svg.mjs";
import ni from "./SVGs/viewOff.svg.mjs";
import li from "./SVGs/visa.svg.mjs";
import mi from "./SVGs/voiceMail_blue.svg.mjs";
import ai from "./SVGs/voiceMail_pink.svg.mjs";
import ci from "./SVGs/voiceMail_yellow.svg.mjs";
import si from "./SVGs/volumeDown.svg.mjs";
import pi from "./SVGs/volumeLevelHigh_blue.svg.mjs";
import gi from "./SVGs/volumeLevelHigh_pink.svg.mjs";
import Si from "./SVGs/volumeLevelHigh_yellow.svg.mjs";
import fi from "./SVGs/volumeMedium.svg.mjs";
import vi from "./SVGs/volumeOff.svg.mjs";
import ui from "./SVGs/volumeUp.svg.mjs";
import di from "./SVGs/warningTriangle.svg.mjs";
import wi from "./SVGs/waveform.svg.mjs";
import ki from "./SVGs/webcamVideo_blue.svg.mjs";
import Pi from "./SVGs/webcamVideo_pink.svg.mjs";
import Bi from "./SVGs/webcamVideo_yellow.svg.mjs";
import Ci from "./SVGs/youtube.svg.mjs";
import hi from "./SVGs/zap.svg.mjs";
const Zc = o, jc = r, Jc = t, Xc = e, _c = i, $c = n, os = l, rs = m, ts = a, es = c, is = s, ns = p, ls = g, ms = S, as = f, cs = v, ss = u, ps = d, gs = w, Ss = k, fs = P, vs = B, us = C, ds = h, ws = Y, ks = y, Ps = A, Bs = b, Cs = M, hs = V, Ys = I, ys = L, As = T, bs = F, Ms = H, Vs = G, Is = E, Ls = U, Ts = W, Fs = D, Hs = O, Gs = R, Es = x, Us = q, Ws = N, Ds = K, Os = z, Rs = Q, xs = Z, qs = j, Ns = J, Ks = X, zs = _, Qs = $, Zs = oo, js = ro, Js = to, Xs = eo, _s = io, $s = no, op = lo, rp = mo, tp = ao, ep = co, ip = so, np = po, lp = go, mp = So, ap = fo, cp = vo, sp = uo, pp = wo, gp = ko, Sp = Po, fp = Bo, vp = Co, up = ho, dp = Yo, wp = yo, kp = Ao, Pp = bo, Bp = Mo, Cp = Vo, hp = Io, Yp = Lo, yp = To, Ap = Fo, bp = Ho, Mp = Go, Vp = Eo, Ip = Uo, Lp = Wo, Tp = Do, Fp = Oo, Hp = Ro, Gp = xo, Ep = qo, Up = No, Wp = Ko, Dp = zo, Op = Qo, Rp = Zo, xp = jo, qp = Jo, Np = Xo, Kp = _o, zp = $o, Qp = or, Zp = rr, jp = tr, Jp = er, Xp = ir, _p = nr, $p = lr, og = mr, rg = ar, tg = cr, eg = sr, ig = pr, ng = gr, lg = Sr, mg = fr, ag = vr, cg = ur, sg = dr, pg = wr, gg = kr, Sg = Pr, fg = Br, vg = Cr, ug = hr, dg = Yr, wg = yr, kg = Ar, Pg = br, Bg = Mr, Cg = Vr, hg = Ir, Yg = Lr, yg = Tr, Ag = Fr, bg = Hr, Mg = Gr, Vg = Er, Ig = Ur, Lg = Wr, Tg = Dr, Fg = Or, Hg = Rr, Gg = xr, Eg = qr, Ug = Nr, Wg = Kr, Dg = zr, Og = Qr, Rg = Zr, xg = jr, qg = Jr, Ng = Xr, Kg = _r, zg = $r, Qg = ot, Zg = rt, jg = tt, Jg = et, Xg = it, _g = nt, $g = lt, oS = mt, rS = at, tS = ct, eS = st, iS = pt, nS = gt, lS = St, mS = ft, aS = vt, cS = ut, sS = dt, pS = wt, gS = kt, SS = Pt, fS = Bt, vS = Ct, uS = ht, dS = Yt, wS = yt, kS = At, PS = bt, BS = Mt, CS = Vt, hS = It, YS = Lt, yS = Tt, AS = Ft, bS = Ht, MS = Gt, VS = Et, IS = Ut, LS = Wt, TS = Dt, FS = Ot, HS = Rt, GS = xt, ES = qt, US = Nt, WS = Kt, DS = zt, OS = Qt, RS = Zt, xS = jt, qS = Jt, NS = Xt, KS = _t, zS = $t, QS = oe, ZS = re, jS = te, JS = ee, XS = ie, _S = ne, $S = le, of = me, rf = ae, tf = ce, ef = se, nf = pe, lf = ge, mf = Se, af = fe, cf = ve, sf = ue, pf = de, gf = we, Sf = ke, ff = Pe, vf = Be, uf = Ce, df = he, wf = Ye, kf = ye, Pf = Ae, Bf = be, Cf = Me, hf = Ve, Yf = Ie, yf = Le, Af = Te, bf = Fe, Mf = He, Vf = Ge, If = Ee, Lf = Ue, Tf = We, Ff = De, Hf = Oe, Gf = Re, Ef = xe, Uf = qe, Wf = Ne, Df = Ke, Of = ze, Rf = Qe, xf = Ze, qf = je, Nf = Je, Kf = Xe, zf = _e, Qf = $e, Zf = oi, jf = ri, Jf = ti, Xf = ei, _f = ii, $f = ni, ov = li, rv = mi, tv = ai, ev = ci, iv = si, nv = pi, lv = gi, mv = Si, av = fi, cv = vi, sv = ui, pv = di, gv = wi, Sv = ki, fv = Pi, vv = Bi, uv = Ci, dv = hi;
export {
  Zc as AddToFolder,
  jc as AddedtoFolder,
  Jc as AiWand,
  Xc as AlarmBell,
  _c as AlignBottom,
  $c as AlignCenter,
  os as AlignLeft,
  rs as AlignMiddle,
  ts as AlignRight,
  es as AlignTop,
  is as Amex,
  ns as ApplePay,
  ls as ArrowBack,
  ms as ArrowCursorBlue,
  as as ArrowCursorPink,
  cs as ArrowCursorYellow,
  ss as ArrowDown,
  ps as ArrowRight,
  gs as ArrowUp,
  Ss as Attachment,
  fs as AudioModified,
  vs as BlankCalendarBlue,
  us as BlankCalendarPink,
  ds as BlankCalendarYellow,
  ws as Brain,
  ks as BusinessStartupBlue,
  Ps as BusinessStartupPink,
  Bs as BusinessStartupYellow,
  Cs as Calendar,
  hs as CameraBlue,
  Ys as CameraPink,
  As as CameraVideoBlue,
  bs as CameraVideoPink,
  Ms as CameraVideoYellow,
  ys as CameraYellow,
  Vs as ChatBubbleTypingOvalBlue,
  Is as ChatBubbleTypingOvalPink,
  Ls as ChatBubbleTypingOvalYellow,
  Ts as ChatTwoBubblesSquareBlue,
  Fs as ChatTwoBubblesSquarePink,
  Hs as ChatTwoBubblesSquareYellow,
  Gs as Check,
  Es as CheckCircle,
  Us as ChevronDown,
  Ws as ChevronLeft,
  Ds as ChevronRight,
  Os as ChevronUp,
  Rs as CircleCheck,
  xs as CircleClockBlack,
  qs as CircleClockBlue,
  Ns as CircleClockPink,
  Ks as CircleClockYellow,
  zs as Close,
  Qs as Cog,
  Zs as Compass,
  js as ControlsForward,
  Js as ControlsPause,
  Xs as ControlsPlay,
  _s as ControlsRecord,
  $s as ControlsRewind,
  op as ControlsStop,
  rp as DashboardGaugeBlue,
  tp as DashboardGaugePink,
  ep as DashboardGaugeYellow,
  ip as DinersClub,
  np as Discover,
  lp as DownloadBottom,
  mp as DownloadSquareBlue,
  ap as DownloadSquarePink,
  cp as DownloadSquareYellow,
  sp as Dropbox,
  pp as EmptyClipboardBlue,
  gp as EmptyClipboardPink,
  Sp as EmptyClipboardYellow,
  fp as ErlenmeyerFlaskBlue,
  vp as ErlenmeyerFlaskPink,
  up as ErlenmeyerFlaskYellow,
  dp as Error,
  wp as ExpandHorizontal,
  kp as ExpandVertical,
  Pp as Facebook,
  Bp as Favorite,
  Cp as FavoriteFilled,
  hp as FileDouble,
  Yp as Filter,
  yp as FilterImage,
  Ap as FilterMusic,
  bp as FilterPlus,
  Mp as FilterVideo,
  Vp as FolderStar,
  Ip as GenerateImage,
  Lp as GenerateVideo,
  Tp as GitHub,
  Fp as GooglePay,
  Hp as GraphPieChartBlue,
  Gp as GraphPieChartPink,
  Ep as GraphPieChartYellow,
  Up as GridRulesBlue,
  Wp as GridRulesPink,
  Dp as GridRulesYellow,
  Op as HappyFaceBlue,
  Rp as HappyFacePink,
  xp as HappyFaceYellow,
  qp as HeadphonesCustomer,
  Np as HelpChatBlue,
  Kp as HelpChatPink,
  zp as HelpChatYellow,
  Qp as HomeBlue,
  Zp as HomePink,
  jp as HomeYellow,
  Jp as HourGlassBlue,
  Xp as HourGlassPink,
  _p as HourGlassYellow,
  $p as House,
  og as Image,
  rg as ImageModified,
  tg as InformationCircle,
  eg as InformationCircleInverted,
  ig as Instagram,
  ng as InterfaceAlertAlarmBellBlue,
  lg as InterfaceAlertAlarmBellPink,
  mg as InterfaceAlertAlarmBellYellow,
  ag as InterfaceAwardTrophyBlue,
  cg as InterfaceAwardTrophyPink,
  sg as InterfaceAwardTrophyYellow,
  pg as InterfaceCursorArrowBlue,
  gg as InterfaceCursorArrowPink,
  Sg as InterfaceCursorArrowYellow,
  fg as InterfaceFavoriteLikeBlue,
  vg as InterfaceFavoriteLikePink,
  ug as InterfaceFavoriteLikeYellow,
  dg as InterfaceImageVideoAudioSubtitlesBlue,
  wg as InterfaceImageVideoAudioSubtitlesPink,
  kg as InterfaceImageVideoAudioSubtitlesYellow,
  Pg as InterfaceLightingLightBulbBlue,
  Bg as InterfaceLightingLightBulbPink,
  Cg as InterfaceLightingLightBulbYellow,
  hg as InterfaceSearchBlue,
  Yg as InterfaceSearchPink,
  yg as InterfaceSearchYellow,
  Vg as KeyboardArrowRight,
  Ag as KeyboardBlue,
  bg as KeyboardPink,
  Mg as KeyboardYellow,
  Ig as LayersBlue,
  Lg as LayersPink,
  Tg as LayersYellow,
  Fg as LayoutWindowBlue,
  Hg as LayoutWindowPink,
  Gg as LayoutWindowYellow,
  Eg as LinkedIn,
  Ug as LoadingRing,
  Wg as Lock,
  Dg as LockUnlock,
  Og as LoginBlue,
  Rg as LoginPink,
  xg as LoginYellow,
  qg as LogoStoryblocks,
  Ng as LogoStoryblocksGray,
  Kg as LogoStoryblocksWhite,
  zg as Maestro,
  Qg as MagicWandBlue,
  Zg as MagicWandPink,
  jg as MagicWandYellow,
  Jg as Maker,
  Xg as Mastercard,
  _g as MeetingCamera,
  $g as MegaphoneBlue,
  oS as MegaphonePink,
  rS as MegaphoneYellow,
  tS as Microphone,
  eS as MicrophoneOff,
  iS as MoneyCashBillBlue,
  nS as MoneyCashBillPink,
  lS as MoneyCashBillYellow,
  mS as MoneyWalletBlue,
  aS as MoneyWalletPink,
  cS as MoneyWalletYellow,
  sS as MusicSound,
  pS as NavigationMenuHorizontal,
  gS as NavigationMenuVertical,
  SS as NewStickyNoteBlue,
  fS as NewStickyNotePink,
  vS as NewStickyNoteYellow,
  uS as OneFingerTapBlue,
  dS as OneFingerTapPink,
  wS as OneFingerTapYellow,
  kS as OpenBookBlue,
  PS as OpenBookPink,
  BS as OpenBookYellow,
  CS as PanelCollapse,
  hS as PanelExpand,
  YS as ParagraphLeftAlign,
  yS as ParagraphsCenterAlign,
  AS as ParagraphsRightAlign,
  bS as PayPal,
  MS as PenBlue,
  VS as PenPink,
  IS as PenYellow,
  LS as Pencil,
  TS as PicturesFolderMemoriesBlue,
  FS as PicturesFolderMemoriesPink,
  HS as PicturesFolderMemoriesYellow,
  GS as PinBlue,
  ES as PinPink,
  US as PinYellow,
  WS as Pinterest,
  DS as PlayListBlue,
  OS as PlayListPink,
  RS as PlayListYellow,
  xS as PlayVideo,
  qS as Plus,
  NS as ProfileAvatar,
  KS as Questionmark,
  zS as Refresh,
  QS as ScreenTvBlue,
  ZS as ScreenTvPink,
  jS as ScreenTvYellow,
  JS as ScriptBlue,
  XS as ScriptPink,
  _S as ScriptYellow,
  $S as Search,
  of as SearchSimilar,
  rf as SettingMenu,
  tf as Share,
  ef as ShoppingCartBlue,
  nf as ShoppingCartPink,
  lf as ShoppingCartYellow,
  mf as Snapchat,
  af as Sparkle,
  cf as Sparkles,
  sf as Stamp,
  pf as StarFourSided,
  gf as StopwatchBlue,
  Sf as StopwatchPink,
  ff as StopwatchYellow,
  vf as Stripe,
  uf as SunCloudBlue,
  df as SunCloudPink,
  wf as SunCloudYellow,
  kf as TextBold,
  Pf as TextInputArea,
  Bf as TextItalic,
  Cf as TextStrikeThrough,
  hf as TextStyle,
  Yf as TextUnderline,
  yf as ThirdEye,
  Af as ThumbDown,
  bf as ThumbUp,
  Mf as Trash,
  Vf as TravelMapEarthBlue,
  If as TravelMapEarthPink,
  Lf as TravelMapEarthYellow,
  Tf as Twitter,
  Ff as UploadBottom,
  Hf as UploadCircleBlue,
  Gf as UploadCirclePink,
  Ef as UploadCircleYellow,
  Uf as UserCircleSingleBlue,
  Wf as UserCircleSinglePink,
  Df as UserCircleSingleYellow,
  Of as UserSingleBlue,
  Rf as UserSinglePink,
  xf as UserSingleYellow,
  qf as Venmo,
  Nf as VerticalSliderSquareBlue,
  Kf as VerticalSliderSquarePink,
  zf as VerticalSliderSquareYellow,
  Qf as Video,
  Zf as VideoEditPeel,
  jf as VideoEditSplit,
  Jf as VideoModified,
  Xf as VideoPlayerAlternate,
  _f as View,
  $f as ViewOff,
  ov as Visa,
  rv as VoiceMailBlue,
  tv as VoiceMailPink,
  ev as VoiceMailYellow,
  iv as VolumeDown,
  nv as VolumeLevelHighBlue,
  lv as VolumeLevelHighPink,
  mv as VolumeLevelHighYellow,
  av as VolumeMedium,
  cv as VolumeOff,
  sv as VolumeUp,
  pv as WarningTriangle,
  gv as Waveform,
  Sv as WebcamVideoBlue,
  fv as WebcamVideoPink,
  vv as WebcamVideoYellow,
  uv as Youtube,
  dv as Zap
};
